
import React, { useState, useRef } from "react";
import { Link } from 'react-router-dom'

const FetchData = () => {
    // initialize the state variable with an empty array
    const [data, setData] = useState([]);

    // define the function that fetches the data
    const fetchData = async () => {
        debugger;
        // get the response from the API endpoint
        const response = await fetch("https://customsearch.googleapis.com/customsearch/v1?cx=56bae2450944840f4&q=" + inputRef.current.value + "&key=AIzaSyCUlUXZQwnxwMclRS124WqVzpABIPkSz7s");
        // parse the response as JSON
        const json = await response.json();
        // update the state variable with the JSON data
        // alert(JSON.stringify(json));
        setData(json['items'].length > 0 ? json['items'] : []);
    };

    const inputRef = useRef(null);

    const handleSubmit = (event) => {
        event.preventDefault();

    };

    // return the JSX element
    return (
        <>
            <form onSubmit={handleSubmit}>
                <input type="text" name="s" id="search" placeholder="Search" ref={inputRef} />
                <button type="submit" onClick={fetchData}>
                    <i className="fa fa-search" />
                </button>
            </form>
            
            {data.length > 0 ? (
            <>
            {data.map((item, ind) => (
                <div id="cssmenu3" className="menu-one-page-menu-container mt-1">
                    <ul className="menu">
                        <li className="menu-item menu-item-type-custom menu-item-object-custom">
                            {/* <Link target="_blank" to={item['link']}><strong>{item['htmlTitle']}</strong></Link> */}
                            <u><Link target="_blank" to={item['link']} dangerouslySetInnerHTML={ {__html: item['htmlTitle'] }}></Link></u>
                            <div dangerouslySetInnerHTML={ {__html: item['htmlSnippet'] }} ></div>
                        </li>
                    </ul>
                </div>
            ))}
            </>
            ) : (
            <p className="mt-4  text-white">No data to display</p>
            )}


            
        </>
    );
};

export default FetchData;